import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'implicit',
    storageKey: 'cmg-ops-auth',
  },
});

// ---- Iframe detection ----
export function isInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true; // cross-origin iframe blocks access to window.top
  }
}

// ---- Shared token store ----
// Writable from AuthContext, readable from API layer.
let _accessToken = null;

export function setAccessToken(token) {
  _accessToken = token;
}

export function getAccessToken() {
  return _accessToken;
}

/**
 * If the URL contains OAuth tokens in the hash fragment,
 * manually trigger getSession so the Supabase client processes them
 * and persists the session to localStorage.
 */
export async function handleOAuthRedirect() {
  const hash = window.location.hash;
  if (
    hash &&
    (hash.includes('access_token') || hash.includes('refresh_token'))
  ) {
    console.log('[Supabase] Processing OAuth hash tokens...');
    const { data, error } = await supabase.auth.getSession();
    if (error) {
      console.error('[Supabase] OAuth exchange error:', error);
    } else if (data.session) {
      console.log('[Supabase] Session established:', data.session.user?.email);
      _accessToken = data.session.access_token;
      // Clean URL
      window.history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search
      );
    }
    return data?.session ?? null;
  }
  return null;
}
